var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',[_c('a-layout-content',{style:({ backgroundColor: 'white' })},[_vm._v(" 12312 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }